import { Chip } from '@elipssolution/harfang';
import { Stack, styled, Typography } from '@mui/material';

import StatusIndicator from './StatusIndicator';
import { DocumentUploadType } from '../types/documentUpload';

const TagChip = styled(Chip)({
	height: '24px !important',
	maxWidth: 'calc(100% - 84px) !important',

	'& > span': {
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		overflowX: 'hidden',
	},
});

const DocumentNameTypography = styled(Typography)({
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	overflowX: 'hidden',
});

const MobileDocumentUploadListRow = ({
	name,
	tag: { color, name: tagName },
	status,
	createdAt,
}: DocumentUploadType) => (
	<Stack
		flexDirection="row"
		alignItems="center"
		gap={0.5}
		height="60px"
		maxWidth="100%"
		boxSizing="border-box"
		paddingLeft="6px !important"
	>
		<Stack flex={1} gap={0.5} maxWidth="calc(100% - 40px)">
			<Stack flexDirection="row" alignItems="center" gap={1}>
				<TagChip color={color} label={tagName} />

				<Typography variant="body2">{createdAt?.toLocaleDateString('fr-FR')}</Typography>
			</Stack>

			<DocumentNameTypography variant="body2">{name}</DocumentNameTypography>
		</Stack>

		<StatusIndicator status={status} />
	</Stack>
);

export default MobileDocumentUploadListRow;
